// src/App.js

import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext'; // Importe o seu AuthProvider
import AdminTools from './pages/AdminTools';

// --- Layouts ---
import Header from './components/Header';
import Footer from './components/Footer';
import AdminLayout from './components/AdminLayout';
import Chatbot from './components/Chatbot';

// --- Páginas Públicas ---
import Home from './pages/Home';
import RpaPage from './pages/RpaPage';
import Termos from './pages/Termos';
import Privacidade from './pages/Privacidade';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import CategoryPage from './pages/CategoryPage';
import Dashboard from './pages/Dashboard'; // Dashboard do usuário comum
import AdminRoute from './components/AdminRoute';
import CertificadoDigital from './pages/CertificadoDigital'; // <-- 1. IMPORTAÇÃO ADICIONADA
import ProspeccaoB2B from './pages/ProspeccaoB2B';
import OptOut from './pages/OptOut';

// --- A NOVA ARQUITETURA SAAS (SHELL E MÓDULOS) ---
import PortalShell from './pages/PortalSaaS/PortalShell'; 
import DashboardCRM from './pages/PortalSaaS/modules/DashboardCRM';
import NormSelector from './pages/PortalSaaS/modules/NormSelector';
import ChatEspecialista from './pages/PortalSaaS/modules/ChatEspecialista';
import Configuracoes from './pages/PortalSaaS/modules/Configuracoes';
import Governanca from './pages/PortalSaaS/modules/Governanca';

// --- INJEÇÃO DOS NOVOS MÓDULOS DO CRM (FASES 2.1 a 2.5) ---
import Empresas from './pages/PortalSaaS/modules/Empresas';
import Obras from './pages/PortalSaaS/modules/Obras';
import ProjetosDosagem from './pages/PortalSaaS/modules/ProjetosDosagem';
import Amostras from './pages/PortalSaaS/modules/Amostras';
import MeusLaudos from './pages/PortalSaaS/modules/MeusLaudos';

// --- Páginas do Painel Admin ---
import AdminDashboard from './pages/AdminDashboard';
import AdminPostList from './pages/AdminPostList';
import AdminCategoryList from './pages/AdminCategoryList'; // <-- Importação real
import AdminAuthorList from './pages/AdminAuthorList';     // <-- Importação real
import PostEditor from './pages/PostEditor';
import CobrancaPix from './pages/CobrancaPix';


/**
 * Componente de Layout para as páginas públicas.
 * Garante que o Header, Footer e Chatbot apareçam em todas as páginas públicas.
 */
const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Outlet /> {/* As páginas públicas (Home, Blog, etc.) serão renderizadas aqui */}
    </main>
    <Chatbot />
    <Footer />
  </>
);


function App() {
  return (
    // O AuthProvider DEVE envolver toda a aplicação para que o contexto de 
    // autenticação (currentUser, logout) funcione em qualquer lugar.
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* ============================================================== */}
          {/* ROTA ISOLADA: ESCUDO LGPD (Página limpa, sem menus)            */}
          {/* ============================================================== */}
          <Route path="/opt-out" element={<OptOut />} />
          
          {/* ============================================================== */}
          {/* ROTA 1: SITE INSTITUCIONAL (Marketing, Leads e SEO)            */}
          {/* Herda o Header e o Footer do site público                      */}
          {/* ============================================================== */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/rpa-e-automacao" element={<RpaPage />} /> {/* <-- NOVA ROTA */}
            <Route path="/dashboard" element={<Dashboard />} /> {/* <-- Antigo painel de usuário, pode redirecionar depois */}
            <Route path="/termos-e-condicoes" element={<Termos />} />
            <Route path="/politica-de-privacidade" element={<Privacidade />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/categoria/:slugCategoria" element={<CategoryPage />} />
            <Route path="/blog/categoria/:slugCategoria/:slugPost" element={<BlogPost />} />
            <Route path="/certificado-digital" element={<CertificadoDigital />} />
            <Route path="/admin-tools" element={<AdminTools />} />
          </Route>
          {/* ============================================================== */}
          {/* ROTA 2: PORTAL SAAS (A Estação de Trabalho Enterprise)         */}
          {/* FICA FORA do PublicLayout. Domina 100% da tela.                */}
          {/* ============================================================== */}
          {/* Ponto de Entrada Único (Login e Onboarding) */}
          <Route path="/IAdoAsfalto" element={<PortalShell />} />
          {/* Operação via Slug (ex: pts.dev.br/primo-trade) */}
          <Route path="/:workspaceSlug" element={<PortalShell />}>
          
            {/* Index: se digitar só /slug, vai para o dashboard */}
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardCRM />} />
            
            {/* --- NOVAS ROTAS DO CRM INJETADAS --- */}
            <Route path="empresas" element={<Empresas />} />
            <Route path="obras" element={<Obras />} />
            <Route path="projetos-dosagem" element={<ProjetosDosagem />} /> {/* <-- NOVA ROTA: Guarda-Chuva MeDiNa */}
            <Route path="amostras" element={<Amostras />} />
            <Route path="meus-laudos" element={<MeusLaudos />} />

            <Route path="auditoria" element={<NormSelector />} />
            <Route path="chat-ia" element={<ChatEspecialista />} />
            <Route path="governanca" element={<Governanca />} />
            
            
            <Route path="configuracoes" element={<Configuracoes />} />
          </Route>

          {/* ============================================================== */}
          {/* ROTA 3: PAINEL ADMIN (Seu controle interno PTS DEV)            */}
          {/* ============================================================== */}
          <Route 
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            {/* Redireciona a rota base /admin para /admin/dashboard */}
            <Route index element={<Navigate to="/admin/dashboard" replace />} /> 
            
            {/* Rotas filhas que renderizam dentro do <Outlet /> do AdminLayout */}
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="posts" element={<AdminPostList />} />
            <Route path="posts/novo" element={<PostEditor />} />
            <Route path="posts/editar/:postId" element={<PostEditor />} />
            <Route path="categorias" element={<AdminCategoryList />} /> {/* <-- Rota real */}
            <Route path="autores" element={<AdminAuthorList />} />     {/* <-- Rota real */}
            {/* 2. Adicionamos a nova rota dentro do layout de admin */}
            <Route path="financeiro/cobranca-pix" element={<CobrancaPix />} />
            <Route path="prospeccao" element={<ProspeccaoB2B />} />
          </Route>

          {/* Adicione aqui outras rotas que não usam nenhum layout, como uma página de Login dedicada, se necessário */}

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;